// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ComboBoxController from "./combo_box_controller"
application.register("combo-box", ComboBoxController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NewTagController from "./new_tag_controller"
application.register("new-tag", NewTagController)

import PreserveDetailsController from "./preserve_details_controller"
application.register("preserve-details", PreserveDetailsController)

import ReplyShortcutsController from "./reply_shortcuts_controller"
application.register("reply-shortcuts", ReplyShortcutsController)

import TagSelectorController from "./tag_selector_controller"
application.register("tag-selector", TagSelectorController)
